import React from 'react';

import {
  formatLocaleDate,
  formatLocaleDatetime,
} from '../../../../../../../libs/date-utils/date-formatting';

export default function ResponseDatetime({ submittedAt, publishAt }) {
  if (submittedAt) {
    return <>Published on {formatLocaleDate(submittedAt)}</>;
  }

  return <>Scheduled to publish on {formatLocaleDatetime(publishAt)}</>;
}
